module.exports = __webpack_public_path__ + "static/img/sp-main-visual.a40cc95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp-main-visual.png
// module id = s+tm
// module chunks = 1